import { useQuery } from "@tanstack/react-query";

import { get } from "common/helpers/HTTP";

import type { AgencyDomainConfig } from "../types";

async function getAgencyDomainConfigurationRequest(
  domainName: string,
): Promise<AgencyDomainConfig> {
  return (await get(`agency/domains/${domainName}/config`)).record;
}

export default function useAgencyDomainConfiguration(domainName: string) {
  const {
    data: agencyDomainConfiguration,
    isLoading: isLoadingAgencyDomainConfiguration,
    isFetching: isFetchingAgencyDomainConfiguration,
    refetch: refetchAgencyDomainConfiguration,
    error: agencyDomainConfigurationError,
  } = useQuery({
    queryKey: ["agencyDomainConfiguration", domainName],
    queryFn: () => getAgencyDomainConfigurationRequest(domainName),
  });

  return {
    agencyDomainConfiguration,
    isLoadingAgencyDomainConfiguration,
    isFetchingAgencyDomainConfiguration,
    refetchAgencyDomainConfiguration,
    agencyDomainConfigurationError,
  };
}
